import LookupStatesRequestModel from '../../../generated/types/model/request/LookupStatesRequestModel';

export default class LookupStatesRequestViewModel extends LookupStatesRequestModel {
  protected transformToDTO() {}
  protected transformFromDTO() {}
}
